import BookingView from "./BookingView";

export default BookingView;
